import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/fonts/fonts.js';
import { handlePaymentCompletionTask } from '@adornis/payments/client/handlePaymentCompletionTask.js';
import { getCompanyInfo } from '@ils/config/project-config.js';
import { ExamType } from '@ils/static/enums.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../components/ils-loader.js';

@customElement('ils-payment-processing')
export class ILSPaymentProcessing extends ChemistryLitElement {
  @property({ attribute: 'exam-type' }) examType?: ExamType;
  override styles() {
    return [
      {
        ':host': {
          display: 'flex',
          width: '100%',
          paddingTop: '2px',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '@keyframes rotateX': {
          from: { transform: 'rotateY(0)' },
          to: { transform: 'rotateY(360deg)' },
        },
      },
    ];
  }
  override connectedCallback(): void {
    super.connectedCallback();
    void handlePaymentCompletionTask({
      failureURL: getCompanyInfo(this.examType ?? ExamType.FAMED).paymentFailureUrl,
      successURL: getCompanyInfo(this.examType ?? ExamType.FAMED).paymentSuccessUrl,
    });
  }

  override render() {
    return html`
      <x-flex space="lg" crossaxis-center>
        <x-h1> Ihre Bezahlung wird verarbeitet.... </x-h1>
        <ils-loader exam-type=${this.examType ?? 'platform'} logo-type="small"></ils-loader>
        <x-text ${css({ maxWidth: this.sizes.maxReadableWidth, textAlign: 'center' })}>
          Bitte haben Sie ein wenig Geduld. Nachdem die Bezahlung abgeschlossen ist, werden Sie automatisch
          weitergeleitet.
        </x-text>
      </x-flex>
    `;
  }
}
